module.exports = __webpack_public_path__ + "static/media/rafflesmarina_1.a0748d8e.jpg";